import { TransformInt } from '../../../shared';

export class DriftSweepMeteringRequest {
  @TransformInt()
  batch!: number;
}
